import { useState } from "react";
import { SubscribeForm } from "../SubscribeForm/SubscribeForm";
import styles from "./ExitIntentMat.module.scss";
import cx from "classnames";
import { useExitIntent } from "use-exit-intent";

const saveToLocalStorage = () => {
  localStorage.setItem("exit-intent-date", new Date().toISOString());
};

const getFromLocalStorage = () => {
  const date = localStorage.getItem("exit-intent-date");
  if (date) {
    const parsedDate = new Date(date);
    const now = new Date();
    const diff = now.getTime() - parsedDate.getTime();
    const diffInMinutes = diff / 1000 / 60;
    return diffInMinutes > 60;
  }
  return true;
};

export const ExitIntentMat = () => {
  const [show, setShow] = useState(false);
  const { registerHandler } = useExitIntent({
    mobile: {
      triggerOnIdle: true,
      delayInSecondsToTrigger: 5,
    },
  });

  registerHandler({
    id: "exit-intent-mat",
    handler: () => {
      if (getFromLocalStorage()) {
        setShow(true);
        saveToLocalStorage();
      }
    },
  });

  return (
    <div className={cx(styles.main, { [styles.show]: show })}>
      <div className={styles.container}>
        <div className={styles.title}>Wait! Before you go...</div>
        <div className={styles.description}>
          Grab Exclusive Deals for Books, Courses, Software.
          <br />
          <u>100% of Profits Are Donated</u> To Research-Backed Charities.
        </div>
        <SubscribeForm
          rootClassName={styles.form}
          inputClassName={styles.input}
          buttonClassName={styles.button}
        />
        <button
          className={styles.dismiss}
          onClick={() => {
            setShow(false);
          }}
        >
          No thank you!
        </button>
      </div>
    </div>
  );
};
